import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ab687b7e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "attachment"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = ["href", "onClick"];
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = ["href", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_field = _resolveComponent("van-field");
  const _component_PopupPickerCpt = _resolveComponent("PopupPickerCpt");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_uploader = _resolveComponent("van-uploader");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_image_preview = _resolveComponent("van-image-preview");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.businessId || $data.newAttachments.length > 0 ? (_openBlock(), _createBlock(_component_van_cell_group, {
    key: 0,
    title: "附件列表",
    inset: "",
    class: _normalizeClass({
      'attachment-list': !$options.readonly
    })
  }, {
    default: _withCtx(() => [$props.businessId ? (_openBlock(), _createBlock(_component_ListViewCpt, {
      key: 0,
      ref: "ListViewCpt",
      request: $data.listRequest,
      requestParameter: $data.searchForm,
      isPaging: false,
      onOnListDataChange: $options.onListDataChange
    }, {
      default: _withCtx(({
        item,
        index
      }) => [_createVNode(_component_van_cell, {
        title: item.uploadFileName,
        center: "",
        "title-class": "cell-title-class"
      }, {
        label: _withCtx(() => [_createVNode(_component_van_row, null, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($options.formatSubType(item.attachmentSubType)), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [item.remark ? (_openBlock(), _createElementBlock("div", _hoisted_2, "备注: " + _toDisplayString(item.remark), 1)) : _createCommentVNode("", true)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)]),
        "right-icon": _withCtx(() => [_createElementVNode("a", {
          href: item.previewUrl,
          style: {
            "color": "black",
            "margin-right": "10px"
          },
          onClick: $event => $options.playItem(item, $event)
        }, [_createVNode(_component_van_icon, {
          name: "play-circle-o",
          size: "20px"
        })], 8, _hoisted_3), !$options.readonly ? (_openBlock(), _createBlock(_component_van_icon, {
          key: 0,
          name: "delete-o",
          size: "20px",
          onClick: $event => $options.deleteItem(item, index)
        }, null, 8, ["onClick"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["title"])]),
      _: 1
    }, 8, ["request", "requestParameter", "onOnListDataChange"])) : (_openBlock(), _createBlock(_component_van_list, {
      key: 1,
      finished: true
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newAttachments, (item, index) => {
        return _openBlock(), _createBlock(_component_van_cell, {
          key: item.id,
          title: item.uploadFileName,
          center: "",
          "title-class": "cell-title-class"
        }, {
          label: _withCtx(() => [_createVNode(_component_van_row, null, {
            default: _withCtx(() => [_createVNode(_component_van_col, {
              span: "12"
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($options.formatSubType(item.businessSubType)), 1)]),
              _: 2
            }, 1024), _createVNode(_component_van_col, {
              span: "12"
            }, {
              default: _withCtx(() => [item.remark ? (_openBlock(), _createElementBlock("div", _hoisted_4, "备注: " + _toDisplayString(item.remark), 1)) : _createCommentVNode("", true)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)]),
          "right-icon": _withCtx(() => [_createElementVNode("a", {
            href: item.previewUrl,
            style: {
              "color": "black",
              "margin-right": "10px"
            },
            onClick: $event => $options.playItem(item, $event)
          }, [_createVNode(_component_van_icon, {
            name: "play-circle-o",
            size: "20px"
          })], 8, _hoisted_5), !$options.readonly ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 0,
            name: "delete-o",
            size: "20px",
            onClick: $event => $options.deleteItem(item, index)
          }, null, 8, ["onClick"])) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["title"]);
      }), 128))]),
      _: 1
    }))]),
    _: 1
  }, 8, ["class"])) : _createCommentVNode("", true), !$options.readonly ? (_openBlock(), _createBlock(_component_van_cell_group, {
    key: 1,
    title: "上传",
    inset: "",
    class: "attachment-upload"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_field, {
      modelValue: $data.attachmentSubTypeName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.attachmentSubTypeName = $event),
      readonly: "",
      clickable: true,
      name: "attachmentSubTypeName",
      label: "附件子类型",
      placeholder: "请选择",
      "input-align": "right",
      "error-message-align": "right",
      "right-icon": $options.rightIcon,
      onClickInput: $options.onPopupSubTypeClick,
      onClickRightIcon: $options.onSubTypeCloseClick
    }, null, 8, ["modelValue", "right-icon", "onClickInput", "onClickRightIcon"]), _createVNode(_component_PopupPickerCpt, {
      ref: "PopupPickerCpt",
      columns: $data.attachmentSubTypes,
      columnsFieldNames: $data.subTypeFieldNames,
      onOnPopupPickerSelect: $options.onPopupPickerSelect
    }, null, 8, ["columns", "columnsFieldNames", "onOnPopupPickerSelect"]), _createVNode(_component_van_field, {
      modelValue: $data.remark,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.remark = $event),
      name: "remark",
      label: "备注",
      placeholder: "请输入备注",
      "input-align": "right"
    }, null, 8, ["modelValue"]), _createVNode(_component_van_uploader, {
      class: "uploader",
      multiple: "",
      accept: "*",
      "before-read": $options.beforeRead,
      "after-read": $options.afterRead
    }, {
      default: _withCtx(() => [_createVNode(_component_van_button, {
        block: "",
        icon: "plus",
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode("上传文件")]),
        _: 1
      })]),
      _: 1
    }, 8, ["before-read", "after-read"])]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_van_image_preview, {
    show: $data.showPreview,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.showPreview = $event),
    images: $data.images
  }, _createSlots({
    _: 2
  }, [$data.isImgUrl($data.images[0]) ? {
    name: "image",
    fn: _withCtx(({
      src
    }) => [_createVNode(_component_van_image, {
      src: src,
      style: {
        "width": "100%",
        "height": "100%"
      }
    }, null, 8, ["src"])]),
    key: "0"
  } : $data.isVideoUrl($data.images[0]) ? {
    name: "image",
    fn: _withCtx(({
      src
    }) => [_createElementVNode("video", {
      style: {
        "width": "100%"
      },
      controls: ""
    }, [_createElementVNode("source", {
      src: src
    }, null, 8, ["src"])])]),
    key: "1"
  } : $data.isAudioUrl($data.images[0]) ? {
    name: "image",
    fn: _withCtx(({
      src
    }) => [_createElementVNode("audio", {
      style: {
        "width": "100%"
      },
      controls: ""
    }, [_createElementVNode("source", {
      src: src
    }, null, 8, ["src"])])]),
    key: "2"
  } : undefined]), 1032, ["show", "images"])]);
}